import { Orbit } from 'lucide-react';

export function Brand() {
  return (
    <>
      <span className="brand-symbol">
        <Orbit size={25} strokeWidth={1.6} aria-hidden="true" />
      </span>
      <span className="brand-wordmark">
        <strong>FLG</strong>
        <small>Reinaldo Ferreira</small>
      </span>
    </>
  );
}

export const formatClass = (format: string) =>
  /carrossel/i.test(format)
    ? 'carousel'
    : /youtube/i.test(format)
      ? 'youtube'
      : /stor/i.test(format)
        ? 'stories'
        : /reel/i.test(format)
          ? 'reel'
          : 'post';

export function FormatBadge({ format }: { format: string }) {
  return <span className={`format-badge ${formatClass(format)}`}>{format}</span>;
}
